import React, { useMemo, useState } from 'react';
import Checkbox from 'components/commercetools-ui/atoms/checkbox';
import { FacetProps } from './types';
import { useProductList } from '../../context';
import { TermFacet as TermFacetType } from '../../types';

const TermFacet: React.FC<FacetProps> = ({ attribute }) => {
  const { facetsConfiguration, refine } = useProductList();
  const [showAll, setShowAll] = useState(false);

  const facet = useMemo(() => facetsConfiguration[attribute] as TermFacetType, [facetsConfiguration, attribute]);

  const sortedFacets = useMemo(
    () => (facet?.terms ? [...facet.terms].sort((a, b) => a.label.localeCompare(b.label)) : []),
    [facet?.terms],
  );

  const visibleFacets = showAll ? sortedFacets : sortedFacets.slice(0, 5);

  return (
    <div className="flex w-full flex-col gap-4 py-22 lg:px-16">
      {visibleFacets.map(
        (term) =>
          term.label && (
            <Checkbox
              key={term.identifier}
              checked={term.selected}
              onChange={() => refine(attribute, term.key)}
              label={term.count ? term.label : ''}
              count={term.count}
            />
          ),
      )}
      {sortedFacets.length > 5 && (
        <div>
          <button className="text-blue-500 hover:underline" onClick={() => setShowAll((prev) => !prev)}>
            {showAll ? 'See less' : 'See more'}
          </button>
        </div>
      )}
    </div>
  );
};

export default TermFacet;
